import script from "./CommonFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonFooter.vue?vue&type=script&setup=true&lang=js"

import "./CommonFooter.vue?vue&type=style&index=0&id=e2bf70fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2bf70fa"]])

export default __exports__